export default "__VITE_ASSET__05998a25__"